<template>
  <ul class="panel-list">
    <li
      v-for="item in list"
      :key="item.label"
      class="panel-list__item"
    >
      <label class="panel-list__label">
        <input
          type="checkbox"
          v-model="selectValue"
          :value="item.label"
          :name="$attrs.name"
          class="panel-list__input"
        >
        <div class="panel-list__box">
          <span class="panel-list__text">{{ item.value }}</span>
        </div>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  name: "PanelList",
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    select: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    selectValue: {
      get () {
        return this.select
      },
      set (value) {
        this.$emit('change', value)
      },
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.panel-list {
  display: flex;
  flex-wrap: wrap;
  margin: -5px -5px 30px;
  padding: 0;
  justify-content: center;

  &__item {
    display: block;
    padding: 5px;
  }
  &__input {
    display: none;
  }
  &__input:checked + &__box {
    // background-color: $col_temp_key1;
  }
  &__input:checked + &__box &__text {
    color: $col_white;
    background: $col_def_gradient;
    border-radius: 50%;
    -webkit-background-clip: unset;
    -webkit-text-fill-color: white;
  }
  &__box {
    display: block;
    background: $col_def_gradient;
    position: relative;
    transition: 0.2s;
    border-radius: 50%;
    width: 27vw;
    height: 27vw;
    max-width: 150px;
    max-height: 150px;

    &::before{
      content: "";
      width: 100%;
      height: 100%;
      background: white;
      position: absolute;
      top: 0;
      left: 0;
      padding: 2px;
      border-radius: 50%;
      background-clip: content-box;
    }
    &::after{
      content: "";
    }
  }
  &__text {
    position: absolute;
    top: 0;
    left: 0px;
    color: $col_black;
    font-weight: bold;
    font-size: 11px;
    text-align: center;
    white-space: pre-line;
    overflow-wrap: break-word;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    justify-content: center;
    align-items: center;
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    line-height: 1.23;
    @include mq('w320'){
      font-size: 13px;
    }
    @include mq('w768'){
      font-size: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Subscription/PanelList.vue